import { render, staticRenderFns } from "./AppFooterComponent.vue?vue&type=template&id=659f7650&scoped=true"
var script = {}
import style0 from "./AppFooterComponent.vue?vue&type=style&index=0&id=659f7650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f7650",
  null
  
)

export default component.exports